import type { RootState } from '../reducers/rootReducer.ts';
import { CurrentUserSelector } from './userSelectors.ts';

export const companiesSelector = (state: RootState) => state.companyReducer.companies;
export const companiesAreLoadingSelector = (state: RootState) => state.companyReducer.companiesAreLoading;

export const currentUserCompany = (state: RootState) =>
  state.companyReducer.companies.find((x) => x.id == CurrentUserSelector(state)?.companyId)?.name;

